export const usageMetricIdValidator =
  (usageMetrics: Array<{ id: string }>) => (usageMetricId: unknown) => {
    if (typeof usageMetricId !== 'string') return undefined

    const validUsageMetric = usageMetrics.find(
      metric => metric.id === usageMetricId
    )

    return validUsageMetric ? undefined : 'This field is required'
  }
